module.exports = __webpack_public_path__ + "static/media/ic_kudos.7d630db8.svg";